module.exports = __webpack_public_path__ + "img/img_4.ab47f7a1.png";